import { render, staticRenderFns } from "./DataTablesComponent.vue?vue&type=template&id=7d98fb1c&"
import script from "./DataTablesComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports